import { NavLink, Routes, Route } from "react-router-dom";
import { Sun, CalendarDays, History } from "lucide-react";
import { Header } from "@/components/kv";
import { useT } from "@/lib/i18n";
import StaffToday from "./StaffToday";
import StaffSchedule from "./StaffSchedule";
import StaffHistory from "./StaffHistory";

const NAV = [
  { to: "/staff", key: "today", icon: Sun, end: true },
  { to: "/staff/schedule", key: "schedule", icon: CalendarDays },
  { to: "/staff/history", key: "history", icon: History },
];

export default function StaffApp() {
  const { t } = useT();
  return (
    <div className="min-h-screen pb-24">
      <Header />
      <main className="max-w-2xl mx-auto px-4 sm:px-6 pt-6">
        <Routes>
          <Route index element={<StaffToday />} />
          <Route path="schedule" element={<StaffSchedule />} />
          <Route path="history" element={<StaffHistory />} />
        </Routes>
      </main>
      <nav className="fixed bottom-0 inset-x-0 z-30 bg-white/90 backdrop-blur-md border-t border-[#E8DFD0] pb-[env(safe-area-inset-bottom)]">
        <div className="max-w-2xl mx-auto grid grid-cols-3">
          {NAV.map(({ to, key, icon: Icon, end }) => (
            <NavLink key={key} to={to} end={end} data-testid={`staff-nav-${key}`}
              className={({ isActive }) => `flex flex-col items-center gap-1 py-3 text-xs font-medium transition-colors ${isActive ? "text-[#b8563a]" : "text-stone-500"}`}>
              <Icon className="h-5 w-5" />
              {t(`staffnav.${key}`)}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
